module.exports = __webpack_public_path__ + "static/media/Pic5.717afa91.jpeg";